import { createSelector } from '@reduxjs/toolkit';

import { selectLowestActiveTaxonomyLabel } from 'src/redux/productsQuery/selectors/selectLowestActiveTaxonomyLabel';
import { buildShopPageTitle } from 'src/utils/buildShopPageTitle';
import { selectMatchedTaxonomyEntry } from './selectMatchedTaxonomyEntry';

/**
 * The shop PLP's HTML title. Derived from the same matched taxonomy entry that
 * drives the h1, so the title stays in sync as content is re-selected on
 * client-side filter/navigation changes. When the page has no content heading,
 * it falls back to the lowest active taxonomy level's label.
 */
export const selectShopPageTitle = createSelector(
  [selectMatchedTaxonomyEntry, selectLowestActiveTaxonomyLabel],
  (matchedEntry, taxonomyLabel) =>
    buildShopPageTitle({
      heading: matchedEntry?.content?.heading,
      pageTitleOverride: matchedEntry?.content?.pageTitleOverride,
      taxonomyLabel,
    }),
);
